export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "column_contract": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contrat"])},
        "column_product": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Produit"])},
        "column_customer": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Client"])},
        "column_status": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Statut"])},
        "price_per_month": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("price")), " / mois"])},
        "cancelled_on": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Résilié le ", _interpolate(_named("date"))])}
      },
      "en": {
        "column_contract": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contract"])},
        "column_product": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Product"])},
        "column_customer": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Customer"])},
        "column_status": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Status"])},
        "price_per_month": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("price")), " / month"])},
        "cancelled_on": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Cancelled on ", _interpolate(_named("date"))])}
      }
    }
  })
}
